/**
 * 注销cas
 * @param url 客户端的注销回调函数 http://xxxxxx
 * @param loginFlag 客户端通过接口获取的登录标识 loginFlag
 */
import $ from 'jquery'
export function logoutCas(url, loginFlag) {
  $.ajax({
    url: process.env.VUE_APP_API_URL + 'logoutClient.do?loginFlag=' + loginFlag,
    async: true,
    type: 'get',
    dataType: 'JSONP',
    jsonp: 'callback',
    jsonpCallback: 'jsonpCallback',
    success: function(data) {
      if (data && data !== '') { // 第三方登录进来
        window.top.location.href = data + url // 注销：第三方、cas、客户端
      } else { // 非第三方登录进来
        window.top.location.href = process.env.VUE_APP_API_URL + 'logout?service=' + url // 注销：cas、客户端
      }
    }
  })
}




// WEBPACK FOOTER //
// ./src/utils/logoutCas.js